export const UNIT_TOPIC = '/user/topic/unit';

export enum UnitMessages {
  DeclaroUnitUpdateMessage = 'DeclaroUnitUpdateMessage',
  ExternalUnitsReadyMessage = 'ExternalUnitsReadyMessage',
}
